import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2bbaa96d&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=2bbaa96d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbaa96d",
  null
  
)

/* custom blocks */
import block0 from "./index.vue?vue&type=custom&index=0&blockType=sellerMenu&class=float-left"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/data2/workspace/sc-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bbaa96d')) {
      api.createRecord('2bbaa96d', component.options)
    } else {
      api.reload('2bbaa96d', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2bbaa96d&scoped=true&", function () {
      api.rerender('2bbaa96d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/seller/components/groupList/index.vue"
export default component.exports